import { render } from "./SubscribedComponent.vue?vue&type=template&id=3aa79613"
import script from "./SubscribedComponent.vue?vue&type=script&lang=js"
export * from "./SubscribedComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__